export const ReviewEmpty = () => {
  return (
    <div className="flex flex-col items-start w-full gap-2">
      <p className="text-neutral-700 text-paragraph-small font-semibold">Be the first to write a review!</p>
      <p className="text-neutral-700 text-paragraph-small font-normal">Tell others what you think!</p>
    </div>
  );
};

export default ReviewEmpty;
